// Centralized site-wide branding & contact info.
// Change these values here and they update everywhere.
const SITE = {
  name: "American Companion Council",
  shortName: "ACC",
  orgName: "American Companion Council",
  orgShort: "ACC",
  email: "james@allamericancompanioncouncil.com",
  phone: "(228) 696-4218",
  phoneHref: "tel:+12286964218",
  emailHref: "mailto:james@allamericancompanioncouncil.com",
  supportHours: "Mon-Fri, 9AM-5PM EST",
};

export default SITE;